const token = localStorage.getItem('token')

export const get_renovation_month = async () =>
{
  try {
    const url = `${ process.env.REACT_APP_API_GCOM_URL }/customers/renovations/month`;
    const params = {
      method: 'GET',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        'Accept': 'application/json',
        "Authorization": `Bearer ${ token }`
      },
    };

    const response = await fetch(url, params);
    const result = await response.json()
    return result

  } catch (error) {
    console.log(error)
    return null
  }
}

export const get_renovation_nexttendays = async () =>
{
  try {
    const url = `${ process.env.REACT_APP_API_GCOM_URL }/customers/renovations/nexttendays`;
    const params = {
      method: 'GET',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        'Accept': 'application/json',
        "Authorization": `Bearer ${ token }`
      },
    };

    const response = await fetch(url, params);
    const result = await response.json()
    return result

  } catch (error) {
    console.log(error)
    return null
  }
}


export const send_email_report = async () => {
  try {
    const url = `${process.env.REACT_APP_API_GCOM_URL}/monitor/send_email_report`;
    const params = {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        'Accept': 'application/json',
        "Authorization": `Bearer ${token}`
      },
    };

    const response = await fetch(url, params);
    const result = await response.json()
    return result

  } catch (error) {
    console.log(error)
    return null
  }
}


export const renovation_customer = async (data) => {
  try {
    const url = `${process.env.REACT_APP_API_GCOM_URL}/customers/renovation`;
    const params = {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        'Accept': 'application/json',
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify(data)
    };

    const response = await fetch(url, params);
    const result = await response.json()
    return result

  } catch (error) {
    console.log(error)
    return null
  }
}


